//#region src/types/websocket/events.ts
let WebSocketEventSource = /* @__PURE__ */ function(WebSocketEventSource$1) {
	WebSocketEventSource$1["Server"] = "proj-airi:server-runtime";
	WebSocketEventSource$1["StageWeb"] = "proj-airi:stage-web";
	WebSocketEventSource$1["StageTamagotchi"] = "proj-airi:stage-tamagotchi";
	return WebSocketEventSource$1;
}({});
let ContextUpdateStrategy = /* @__PURE__ */ function(ContextUpdateStrategy$1) {
	ContextUpdateStrategy$1["ReplaceSelf"] = "replace-self";
	ContextUpdateStrategy$1["AppendSelf"] = "append-self";
	return ContextUpdateStrategy$1;
}({});

//#endregion
export { ContextUpdateStrategy, WebSocketEventSource };
//# sourceMappingURL=index.mjs.map